export const enum TitleBarKey {
    // TODO先注释掉，临时套用TitlebarKey.LOCAL_FILE_UPLOAD车牌，灰度放开需要改
    // LOCAL_TO_SYNC_DOC = 'local-to-sync-doc'
    PRESENTATION = 'presentation',

    // 以下在项目中未使用
    AUTH = 'auth',
    HOME = 'home',
    LOCAL_FILE_SAVE = 'local-file-save',
    READONLY_TIPS = 'readonly-tips',
    BADGE = 'badge',
    COLLABORATION = 'collaboration',
    QQ_GROUP_AIO = 'qq-group-aio',
    SAVE_TIPS = 'save-tips',
    FILE_MENU = 'file-menu',
    MORE_MENU = 'more-menu',
    RELATE_MENU = 'relate-menu',
    SHARE = 'share',
    ACCOUNT_AVATAR = 'account-avatar',
    LOGIN = 'login',
    MASK = 'mask',
    PUSHER = 'pusher',
    MODE = 'mode',
    TAG = 'tag',
    DIVIDER = 'divider',
    TENCENT_MEETING = 'tencent-meeting',
    CERTIFICATION = 'certification',
    PC_HEADER = 'pc-header',
}
